import { render } from "./HotKeyList.vue?vue&type=template&id=9ac83e1a&scoped=true&ts=true"
import script from "./HotKeyList.vue?vue&type=script&lang=ts"
export * from "./HotKeyList.vue?vue&type=script&lang=ts"

import "./HotKeyList.vue?vue&type=style&index=0&id=9ac83e1a&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ac83e1a"]])

export default __exports__